import React from "react";
import { Tabs, Col, Row } from "antd";
import { BarsOutlined } from "@ant-design/icons";
import MonthlyStatusReport from "./MonthlyStatusReport";
import DailyStatusReport from "./DailyStatusReport";

const MonthlyStatusPlanReports = () => {

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> TARİH BAZLI DURUM RAPORU
          </p>
        </Col>
      </Row>

      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Ay Bazlı" key="1">
          <MonthlyStatusReport />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Gün Bazlı" key="2">
          <DailyStatusReport />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};

export default MonthlyStatusPlanReports;
